const $ = jQuery.noConflict();

'use strict';
const FilterMain = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.sortFilter();
		if (window.innerWidth > 992) {
			this.accFilter();
		}
		if (window.innerWidth < 992) {
			this.mobileFilterPopup();
		}
		$(window).on('load', function() {
			if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
				// Unselect checkboxes
				$('.property-filters__accordion-content input[type="checkbox"]').each(function() {
					$(this).prop('checked', false); // Uncheck the checkbox
				});
				// Clear number input fields
				$('.property-filters__accordion-content input[type="number"]').each(function() {
					$(this).val(''); // Clear the value of the number input
				});
				// Reset form if using a form for filters
				$('.property-filters__btn').trigger('click');
			}
		});
	},

	/** @description slider example description e.g Banner slider */
	accFilter: () => {
		$('.property-filters__accordion-btn').on('click', function(e) {
			$(this).toggleClass('active');
			$(this).next('.property-filters__accordion-content').toggleClass('active');
		});

		// only number allowed
		$('.input-ranger input').on('keydown', function(event) {
			const regex = new RegExp('^[0-9]+$');

			if ((event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') ||
				(event.key >= '0' && event.key <= '9') ||
				regex.test(event.key)) {
				return true;
			} else {
				event.preventDefault();
				return false;
			}
		});

		$('.property-filters__accordion-content').each(function() {
			const $content = $(this);
			const $minInput = $content.find('.min');
			const $maxInput = $content.find('.max');
			const $errorNotification = $content.find('.error-notification');

			$minInput.add($maxInput).on('input', function() {
				validateInputs($minInput, $maxInput, $errorNotification);
			});
		});

		function validateInputs($minInput, $maxInput, $errorNotification) {
			const minValue = parseInt($minInput.val());
			const maxValue = parseInt($maxInput.val());

			if ((!isNaN(minValue) && !isNaN(maxValue)) || ($minInput.val() === '' || $maxInput.val() === '')) {
				if (minValue >= maxValue) {
					$minInput.addClass('error');
					$maxInput.addClass('error');
					$errorNotification.addClass('visible');
				} else {
					$minInput.removeClass('error');
					$maxInput.removeClass('error');
					$errorNotification.removeClass('visible');
				}
			} else {
				$minInput.removeClass('error');
				$maxInput.removeClass('error');
				$errorNotification.removeClass('visible');
			}
		}
	},

	sortFilter: () => {
		$('.js-select-dropdown').on('click', function() {
			$('.js-select-dropdown-list').toggleClass('active-dropdown');
			$(this).toggleClass('active');
		});

		$('.js-select-dropdown-list-item').on('click', function() {
			$('.js-select-dropdown-list-item').removeClass('active-item');
			$(this).addClass('active-item');

			const itemValue = $(this).find('span').data('value');

			$('.js-select-dropdown .js-value').text($(this).find('span').text()).parent().attr('data-value', itemValue);

			$('.js-select-dropdown-list').removeClass('active-dropdown');
			$('.js-select-dropdown').removeClass('active');
		});

		$(document).on('click', function(e) {
			const $clicked = $(e.target);
			if (!$clicked.parents().hasClass('active-dropdown')) {
				$('.js-select-dropdown').removeClass('active');
			}
		});
	},

	mobileFilterPopup: () => {
		$('.js-open-popup').on('click', function() {
			$('.js-open-filters').addClass('open');
			$('.property-listing-block').css({
				'z-index': '99999'
			});
			$('body').addClass('prevent-scroll');
		});
		$('.js-close-popup').on('click', function() {
			$('.js-open-filters').removeClass('open');
			$('.property-listing-block').css({
				'z-index': '2'
			});
			$('body').removeClass('prevent-scroll');
		});

		$('.property-filters__btn-submit').on('click', function() {
			$('.js-close-popup').click();
		});
	}
};

export default FilterMain;


